import Deregulated from "./Deregulated";
import NewYorkFreeTradeZone from "./NewYorkFreeTradeZone";
import { Stack } from "@mui/material";
import Component from "components/Component";
import Visible from "components/common/Visible";
import * as labels from "config.labels";
import { useTranslator } from "store/hooks/staticDataHooks";

const RegulatoryExemptions = ({ program, updateProgram }) => {
  const translateLabel = useTranslator("uiLabels");

  return (
    <Component
      title={translateLabel(labels.PROGRAM_REGULATORY_EXEMPTIONS, {
        default: "Regulatory Exemptions",
      })}
    >
      <Stack gap={1}>
        <Visible byTag={"input.program.newYorkFreeTradeZone"} defaultVisible>
          <NewYorkFreeTradeZone
            state={program.newYorkFreeTradeZone}
            onChange={(state) => updateProgram(state)}
          />
        </Visible>
        <Visible byTag={"input.program.deregulated"} defaultVisible>
          <Deregulated
            state={program.deregulated}
            onChange={(state) => updateProgram(state)}
          />
        </Visible>
      </Stack>
    </Component>
  );
};

export default RegulatoryExemptions;
